import { useCallback } from 'react';

import { useConversationActions } from '@web/conversations/Conversation/ConversationProvider/ConversationProvider';
import { useArchiveConversation } from '@web/conversations/hooks/useArchiveConversation';

type Props = {
  id: ID;
};

export const useArchiveConversationAction = () => {
  const mutation = useArchiveConversation();
  const { archiveConversation } = useConversationActions();

  const { mutateAsync } = mutation;

  const action = useCallback(
    async ({ id }: Props) => {
      await mutateAsync({ id });

      archiveConversation({ id });
    },
    [mutateAsync, archiveConversation]
  );

  return { action, mutation };
};
